import React, { Component } from "react";

import RouterOutlet from "./router-outlet";

export default function Pages(props) {
  return <RouterOutlet {...props} />;
}
